import { render, staticRenderFns } from "./UiModal.vue?vue&type=template&id=a0acc6ee&scoped=true"
import script from "./UiModal.vue?vue&type=script&lang=js"
export * from "./UiModal.vue?vue&type=script&lang=js"
import style0 from "./UiModal.vue?vue&type=style&index=0&id=a0acc6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0acc6ee",
  null
  
)

export default component.exports